<template>
  <div v-show="roletype == 3 ? false:true" class="btnDashboard">
    <a target="_self" @click="dashboard">
      <div :title="$t('navbar.userConsole')" class="btnIcon">
        <span>{{ $t('navbar.userConsole') }}</span>
        <svg-icon class-name='left-menu-logo' icon-class="userconsole"/>
      </div>
    </a>

    <!--<div class="btnTitle"> User Console</div>-->
  </div>
</template>

<script>
import $router from '@/router'
import {recordBehaviorsAfter} from "../../../monitoring/performanceMonitoring";

export default {
  name: "UserConsole",
  data() {
    return {
      roletype: ''
    }
  },
  mounted() {
    let _this = this
    _this.roletype = _this.$store.state.user.roletype
  },
  methods: {
    dashboard() {
      recordBehaviorsAfter($router.history.current).then((res) => {
        if (res.jsonBody.rtnCode == 0) {
          window.location.href = "/console/"
        } else {
          this.$message({
            message: res.jsonBody.msg,
            type: 'error',
            duration: 1000
          })
        }
      }).catch(err => {
        console.log('err', err)
      });
    },
  }
}
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
.btnDashboard {
  display: inline-block;
  text-align: right;
  margin-right: 10px;
  /*line-height: 40px;*/
  cursor: pointer;
  vertical-align: top;

  .btnIcon {
    color: rgba(255, 255, 255, 1);
    font-size: 24px;

    overflow: auto !important;

    span {
      font-size: 14px;
      color: rgba(255, 255, 255, 1);
    }
  }

  .btnTitle {
    font-size: 14px;
    font-family: inter;
    font-weight: 700;
    color: rgba(255, 255, 255, 1);
  }
}
</style>



// WEBPACK FOOTER //
// src/views/layout/components/UserConsole.vue